import { DeliveryMode, OrderMethod } from '../../../../../../../services/exports/Constants';

export default {
  title: 'A encomenda vai demorar mais/menos?',
  text: {
    [OrderMethod.Pickup]:
      'O cliente espera que a encomenda esteja pronta para levantamento em <strong>{{date}}</strong> às <strong>{{time}}</strong><br/> Se necessário, pode alterar a hora aqui.',
    [OrderMethod.OnSite]:
      'O cliente espera o pedido em <strong>{{table}}</strong><br/><strong>{{date}}</strong> às <strong>{{time}}</strong><br/> Se necessário, pode alterar a hora aqui.',
    // A table order whose table the backend could not name.
    on_site_without_table:
      'O cliente espera a encomenda na sua mesa <strong>{{date}}</strong> às <strong>{{time}}</strong><br/> Se necessário, pode alterar a hora aqui.',
    [OrderMethod.Delivery]: {
      [DeliveryMode.Internal]:
        'O cliente espera que a encomenda seja entregue em <strong>{{date}}</strong> às <strong>{{time}}</strong><br/> Se necessário, pode alterar a hora aqui.',
      [DeliveryMode.External]:
        'O estafeta chegará para levantar a encomenda às <strong>{{time}}{{confidenceLabel}}</strong>',
    },
  },
  labels: {
    today: 'Hoje',
  },
  confidence_labels: {
    estimated: ' (estimado!)',
    confirmed: '',
  },
  buttons: {
    confirm_pickup: 'Confirmar nova hora de levantamento',
    confirm_on_site: 'Confirmar nova hora de serviço',
    confirm_delivery: 'Confirmar nova hora de entrega',
  },
  confirmation_modal: {
    description: 'Tem a certeza que quer alterar a hora de {{currentPickupTime}} para {{newPickupTime}}?',
    ok_button_text: 'Confirmar nova hora',
    cancel_button_text: 'Não, manter hora original',
  },
};
